import apiClient from './client';

export const planningApi = {
  // List all scenarios with optional filters
  getScenarios: async (opportunityId = null, status = null) => {
    try {
      const params = new URLSearchParams();
      if (opportunityId) params.append('opportunity_id', opportunityId);
      if (status) params.append('status', status);
      
      const response = await apiClient.get(`/api/planning/scenarios?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Failed to get scenarios:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Create a new scenario
  createScenario: async (data) => {
    try {
      const response = await apiClient.post('/api/planning/scenarios', data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to create scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Get scenario details with part comparison
  getScenarioDetail: async (scenarioId) => {
    try {
      const response = await apiClient.get(`/api/planning/scenarios/${scenarioId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get scenario detail:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Update scenario
  updateScenario: async (scenarioId, data) => {
    try {
      const response = await apiClient.put(`/api/planning/scenarios/${scenarioId}`, data);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to update scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Delete (archive) scenario
  deleteScenario: async (scenarioId) => {
    try {
      const response = await apiClient.delete(`/api/planning/scenarios/${scenarioId}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to delete scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Set scenario as the active planning basis for its opportunity.
  activateScenario: async (scenarioId) => {
    try {
      const response = await apiClient.post(`/api/planning/scenarios/${scenarioId}/activate`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to activate scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Recalculate scenario impact
  recalculateScenario: async (scenarioId) => {
    try {
      const response = await apiClient.post(`/api/planning/scenarios/${scenarioId}/calculate`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to recalculate scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Duplicate scenario
  duplicateScenario: async (scenarioId) => {
    try {
      const response = await apiClient.post(`/api/planning/scenarios/${scenarioId}/duplicate`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to duplicate scenario:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  },

  // Get version history
  getVersionHistory: async (scenarioId) => {
    try {
      const response = await apiClient.get(`/api/planning/scenarios/${scenarioId}/versions`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Failed to get version history:', error);
      return {
        success: false,
        error: error.response?.data?.detail || error.message
      };
    }
  }
};
